import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { generateClient } from 'aws-amplify/api';
import { getUrl, uploadData } from 'aws-amplify/storage'; 
import { getCurrentUser } from 'aws-amplify/auth'; 
import { getCourse, listExchangeRates } from '../graphql/queries';
// QUIRÚRGICO: Añadida createNotification a las mutaciones
import { createEnrollment, createNotification } from '../graphql/mutations'; 
import { FiArrowLeft, FiUser, FiTarget, FiBookOpen } from 'react-icons/fi';
import './CoursesPage.css'; 

const CoursePage = () => {
    const { id } = useParams(); 
    const navigate = useNavigate();
    const [course, setCourse] = useState(null);
    const [tasa, setTasa] = useState(1);
    const [loading, setLoading] = useState(true);
    const [imageUrl, setImageUrl] = useState("https://gioscarvaci.com/documento-legal2.png");
    const [videoUrl, setVideoUrl] = useState(null); 
    const [user, setUser] = useState(null);
    const [receiptFile, setReceiptFile] = useState(null);
    const [pagoData, setPagoData] = useState({ bankName: '', referencia: '' });

    useEffect(() => {
        const fetchData = async () => {
            const client = generateClient();
            try {
                // 1. Usuario
                try {
                    const currentUser = await getCurrentUser();
                    setUser(currentUser);
                } catch (e) { setUser(null); }

                // 2. Tasa
                const resTasa = await client.graphql({ query: listExchangeRates, authMode: 'apiKey' });
                setTasa(resTasa.data.listExchangeRates.items[0]?.value || 1);

                // 3. Curso
                const result = await client.graphql({ query: getCourse, variables: { id }, authMode: 'apiKey' });
                const data = result.data.getCourse;
                setCourse(data);

                // 4. Lógica de Imagen Sincronizada
                if (data.thumbnailUrl) {
                    try {
                        const cleanKey = data.thumbnailUrl.replace(/^public\//, '');
                        const imgLink = await getUrl({ path: `public/${cleanKey}` });
                        setImageUrl(imgLink.url.toString());
                    } catch (e) {
                        console.error("Error cargando imagen:", e);
                    }
                }

                // 5. Lógica de Video (Promo)
                if (data.promoVideoUrl) {
                    try {
                        const cleanVidKey = data.promoVideoUrl.replace(/^public\//, '');
                        const signedUrl = await getUrl({ 
                            path: `public/${cleanVidKey}`, 
                            options: { expiresIn: 3600 } 
                        });
                        setVideoUrl(signedUrl.url.toString());
                    } catch (err) { 
                        console.error("Error video promo:", err);
                    }
                }

            } catch (error) { 
                console.error("Error general:", error); 
            } finally { 
                setLoading(false); 
            }
        };
        fetchData();
    }, [id]);

    const handleInscripcion = async (e) => {
        e.preventDefault();
        if (!user) return alert("Por favor, inicie sesión.");
        setLoading(true);
        const client = generateClient();
        try {
            const userEmail = user.signInDetails?.loginId || user.username;
            const fileExt = receiptFile.name.split('.').pop();
            const fileName = `recibo-${Date.now()}.${fileExt}`;
            
            await uploadData({ 
                path: `public/course-receipts/${fileName}`, 
                data: receiptFile
            }).result;

            const input = {
                userEmail: userEmail,
                courseId: id,
                courseTitle: course.title,
                amountUSD: parseFloat(course.priceUSD),
                amountBS: parseFloat((course.priceUSD * tasa).toFixed(2)),
                referenceNumber: pagoData.referencia,
                bankName: pagoData.bankName,
                status: "PENDIENTE",
                enrollmentDate: new Date().toISOString(),
                category: fileName 
            };

            await client.graphql({ 
                query: createEnrollment, 
                variables: { input }, 
                authMode: 'userPool' 
            });

            // INYECCIÓN QUIRÚRGICA: Notificar al Dr. Giovanni
            await client.graphql({
                query: createNotification,
                variables: {
                    input: {
                        recipientEmail: "giovanniscarvaciyasociados@gmail.com",
                        title: "🎓 NUEVA INSCRIPCIÓN ACADEMIA",
                        message: `El cliente ${userEmail} reportó pago para el curso: ${course.title}. Ref: ${pagoData.referencia}`,
                        isRead: false
                    }
                },
                authMode: 'userPool'
            });

            alert("✅ ¡Éxito! Tu comprobante ha sido enviado.");
            navigate('/profile');
        } catch (error) { 
            console.error("Error inscripción:", error);
            alert("Error al procesar inscripción."); 
        } finally { 
            setLoading(false); 
        }
    };

    if (loading) return <div className="academy-loading">Cargando...</div>;
    if (!course) return <div className="academy-loading">Curso no encontrado.</div>;

    return (
        <div className="academy-container" style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
            <button onClick={() => navigate('/cursos')} className="btn-back" style={{ marginBottom: '20px', border: 'none', background: 'none', cursor: 'pointer', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '8px', color: '#001f3f' }}>
                <FiArrowLeft /> Volver a la Academia
            </button>

            <div className="product-main-section" style={{ display: 'flex', flexWrap: 'wrap', gap: '30px' }}>
                <div className="product-image-column" style={{ flex: '1', minWidth: '300px' }}>
                    <div style={{ borderRadius: '15px', overflow: 'hidden', boxShadow: '0 8px 20px rgba(0,0,0,0.1)', background: '#f4f4f4' }}>
                        <img 
                            src={imageUrl} 
                            alt="Portada" 
                            style={{ width: '100%', display: 'block' }} 
                            onError={(e) => { e.target.src = "https://gioscarvaci.com/documento-legal2.png"; }}
                        />
                    </div>
                </div>

                <div className="product-info-column" style={{ flex: '2', minWidth: '300px' }}>
                    <h1 style={{ color: '#001f3f' }}>{course.title}</h1>
                    <p style={{ color: '#555', marginBottom: '20px' }}><FiUser /> Instructor: {course.instructor || "Dr. Giovanni Scarvaci"}</p>
                    
                    {videoUrl && (
                        <div style={{ background: '#000', borderRadius: '12px', overflow: 'hidden', marginTop: '10px' }}>
                            <video key={videoUrl} src={videoUrl} controls playsInline controlsList="nodownload" style={{ width: '100%', maxHeight: '450px', display: 'block' }} />
                        </div>
                    )}

                    <div style={{ marginTop: '30px' }}>
                        <h4 style={{ color: '#D4AF37' }}><FiTarget /> Perfil</h4>
                        <p>{course.targetAudience}</p>
                        <h4 style={{ color: '#D4AF37', marginTop: '20px' }}><FiBookOpen /> Contenido</h4>
                        <p style={{ whiteSpace: 'pre-line' }}>{course.description}</p>
                    </div>
                </div>

                <div className="product-buy-column" style={{ flex: '1', minWidth: '280px' }}>
                    <div style={{ padding: '25px', border: '1px solid #D4AF37', borderRadius: '15px', backgroundColor: '#fff', textAlign: 'center' }}>
                        <h2 style={{ color: '#b12704', margin: '0' }}>${course.priceUSD}</h2>
                        <p style={{ color: '#888' }}>Bs. {(course.priceUSD * tasa).toFixed(2)}</p>
                        <hr style={{ margin: '20px 0', opacity: '0.2' }} />
                        
                        {!user ? (
                            <button onClick={() => navigate('/inicio')} style={{ width: '100%', padding: '15px', backgroundColor: '#D4AF37', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>INICIAR SESIÓN PARA INSCRIBIRSE</button>
                        ) : (
                            <form onSubmit={handleInscripcion}>
                                <input type="text" placeholder="Banco emisor" style={{ width: '100%', padding: '10px', marginBottom: '10px', border: '1px solid #ddd', borderRadius: '4px' }} required onChange={e => setPagoData({...pagoData, bankName: e.target.value})} />
                                <input type="text" placeholder="Referencia bancaria" style={{ width: '100%', padding: '10px', marginBottom: '10px', border: '1px solid #ddd', borderRadius: '4px' }} required onChange={e => setPagoData({...pagoData, referencia: e.target.value})} />
                                <div style={{ textAlign: 'left', marginBottom: '10px' }}>
                                    <label style={{ fontSize: '12px', color: '#666' }}>Subir Comprobante:</label>
                                    <input type="file" accept="image/*" required onChange={e => setReceiptFile(e.target.files[0])} style={{ marginTop: '5px', width: '100%' }} />
                                </div>
                                <button type="submit" disabled={loading} style={{ width: '100%', padding: '15px', backgroundColor: '#001f3f', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>
                                    {loading ? 'PROCESANDO...' : 'ENVIAR INSCRIPCIÓN'}
                                </button>
                            </form>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CoursePage;